import React from 'react';
import { useRoutes } from 'react-router-dom';
import { routeConfig } from 'app/providers/router/config/routerConfig';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import FormDataProvider from "../../formValues/ui/FormDataProvider";
import ApplicationFormProvider from "../../applicationForm/ui/ApplicationFormProvider";
import ScrollToTop from "shared/ui/ScrollToTop/ScrollToTop";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import NavigationProvider from './NavigationProvider';
import { Container } from '@mui/material';
import { ThemeSettingsWrapper } from 'app/providers/theme';

const client = new QueryClient(
	{
		defaultOptions: {
			queries: {
				gcTime: Infinity
			}
		}
	}
)
const AppRouter = () => {
	const elements = useRoutes(Object.values(routeConfig))
	return (
		<QueryClientProvider client={client}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<NavigationProvider>
					<ApplicationFormProvider>
						<FormDataProvider>
							<ThemeSettingsWrapper>
								<Container
									maxWidth={"lg"}
									sx={{ backgroundColor: (theme) => theme.palette.global.main }}
								>{elements}</Container>
							</ThemeSettingsWrapper>
							<ScrollToTop/>
						</FormDataProvider>
					</ApplicationFormProvider>
				</NavigationProvider>
			</LocalizationProvider>
		</QueryClientProvider>
	)
}

export default AppRouter
